import NumberPadItem from './components/numberPad/numberPadItem'
import getStore from './store'
import { Store } from 'redux'
import LoggerService from './services/logger.service'
import { getPlatform, getReleaseVersion } from './utilities'
import { enable } from '@zoll/logrocket-base-lib/constants/toggleKeys'
import { allowPwaInstall, getIonicConfig, getUserAgent, isPlatformNative } from './utilities/platform.util'
import { setEnableLocationSearch } from './features/locationSearch/store/locationSearch.actions'
import { Device } from '@capacitor/device'
import { isResumeSessionEnabled } from './features/session/resume/utils/sessionResume.util'
import { isSessionPersistenceEnabled } from './features/session/persist/utils/sessionPersist.util'

const logDeviceId = async () => {
  const deviceId = await Device.getId()
  const deviceInfo = await Device.getInfo()
  LoggerService.log('Device Details:')
  LoggerService.log(`  Device ID: ${deviceId.identifier}`)
  LoggerService.log(`  Model: ${deviceInfo.model}`)
  LoggerService.log(`  OS Version: ${deviceInfo.osVersion}`)
  LoggerService.log(`  iOS Version: ${deviceInfo?.iOSVersion || ''}`)
  LoggerService.log(`  Android SDK Version: ${deviceInfo?.androidSDKVersion || ''}`)
  LoggerService.log(`  WebView Version: ${deviceInfo.webViewVersion}`)
}

const logReduxDevToolsSettings = async () => {
  LoggerService.log(`REACT_APP_REDUX_DEVTOOLS_DISABLED: ${process.env.REACT_APP_REDUX_DEVTOOLS_DISABLED}`)
  if (process.env.REACT_APP_REDUX_DEVTOOLS_DISABLED !== 'true') {
    LoggerService.log(`REACT_APP_REDUX_DEVTOOLS_MAX_AGE: ${process.env.REACT_APP_REDUX_DEVTOOLS_MAX_AGE}`)
    LoggerService.log(`REACT_APP_REDUX_DEVTOOLS_MAX_STATE_SIZE: ${process.env.REACT_APP_REDUX_DEVTOOLS_MAX_STATE_SIZE}`)
    LoggerService.log(
      `REACT_APP_REDUX_DEVTOOLS_MAX_ACTION_SIZE: ${process.env.REACT_APP_REDUX_DEVTOOLS_MAX_ACTION_SIZE}`
    )
  }
}

const logSessionResumeSettings = async () => {
  const timeoutDurationMinutes = process.env.REACT_APP_SESSION_TIMEOUT_DURATION_MINUTES
  LoggerService.log(`REACT_APP_TOGGLE_PERSIST_SESSION_FEATURE: ${process.env.REACT_APP_TOGGLE_PERSIST_SESSION_FEATURE}`)
  LoggerService.log(`REACT_APP_TOGGLE_RESUME_SESSION_FEATURE: ${process.env.REACT_APP_TOGGLE_RESUME_SESSION_FEATURE}`)

  LoggerService.log(`Session Resume is enabled: ${isResumeSessionEnabled()}`)
  LoggerService.log(`REACT_APP_SESSION_TIMEOUT_DURATION_MINUTES: ${timeoutDurationMinutes}`)
  LoggerService.log(`Session persistence is enabled: ${isSessionPersistenceEnabled()}`)
}

const initApp = (): Store => {
  LoggerService.initialize()
  NumberPadItem.initialize()

  const store = getStore()

  const lrLocalStorage = `(${enable}=${localStorage.getItem(enable)})`
  const enableLocationSearch = `${process.env.REACT_APP_ENABLE_LOCATION_SEARCH}` === 'true'

  LoggerService.log('App initialized')
  LoggerService.log(LoggerService.LINE)
  LoggerService.log(`Platform: ${getPlatform()}`)
  LoggerService.log(`UserAgent: ${getUserAgent()}`)
  LoggerService.log(`PWA install allowed: ${allowPwaInstall()}`)
  LoggerService.log(`${getReleaseVersion('Version', 'Build')}`)
  LoggerService.log(`process.env.NODE_ENV: ${process.env.NODE_ENV}`)
  LoggerService.log(`window.location: ${window.location}`)
  LoggerService.log(`REACT_APP_ZOLL_API_URL: ${process.env.REACT_APP_ZOLL_API_URL}`)
  LoggerService.log(`REACT_APP_ENABLE_LOG_ROCKET: ${process.env.REACT_APP_ENABLE_LOG_ROCKET} - ${lrLocalStorage}`)
  LoggerService.log(`REACT_APP_ENABLE_USER_PILOT: ${process.env.REACT_APP_ENABLE_USER_PILOT}`)
  LoggerService.log(`REACT_APP_FORCE_PWA_ON_MOBILE_BROWSERS: ${process.env.REACT_APP_FORCE_PWA_ON_MOBILE_BROWSERS}`)
  LoggerService.log(`REACT_APP_APP_STORE_URL_IOS: ${process.env.REACT_APP_APP_STORE_URL_IOS}`)
  LoggerService.log(`REACT_APP_APP_STORE_URL_ANDROID: ${process.env.REACT_APP_APP_STORE_URL_ANDROID}`)
  LoggerService.log(`REACT_APP_USE_GET_PCR_URL_IN_QR_CODE: ${process.env.REACT_APP_USE_GET_PCR_URL_IN_QR_CODE}`)
  LoggerService.log(`REACT_APP_PERSIST_SHIFT_MINUTES: ${process.env.REACT_APP_PERSIST_SHIFT_MINUTES}`)
  LoggerService.log(`REACT_APP_AUTO_UPLOAD_PCRS_MINUTES: ${process.env.REACT_APP_AUTO_UPLOAD_PCRS_MINUTES}`)
  LoggerService.log(`REACT_APP_ENABLE_LOCATION_SEARCH: ${enableLocationSearch}`)

  logSessionResumeSettings()

  logReduxDevToolsSettings()
  logDeviceId()

  store.dispatch(setEnableLocationSearch(enableLocationSearch))

  if (isPlatformNative()) {
    getIonicConfig()
      .then((ic) => {
        LoggerService.log(`Ionic Config: ${JSON.stringify(ic, null, 2)}`)
        LoggerService.log(LoggerService.LINE)
      })
      .catch((err) => {
        LoggerService.error(`Error getting Ionic Config: ${err}`)
        LoggerService.log(LoggerService.LINE)
      })
  } else {
    LoggerService.log(LoggerService.LINE)
  }

  return store
}

export default initApp
